module.exports = __webpack_public_path__ + "static/media/016ty@4x.b0518336.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/016ty@4x.png
// module id = 420
// module chunks = 0 1